import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f77bdb96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authentication-info ws_ml10" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "ws_ml4" }

import { ref } from 'vue'
import { queryTenantInfo, queryTenantResource } from '@/api'
import { CODE_ENUM } from '@/common'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'base-info',
  setup(__props) {

const $route = useRoute()

const orgId = $route.query.orgId

const info: any = ref([
  {
    label: '客户姓名',
    value: '',
    key: 'orgName',
  },
  {
    label: '联系人',
    value: '',
    key: 'orgContact',
  },
  {
    label: '联系人电话',
    value: '',
    key: 'orgMobile',
  },
  {
    label: '销售人员',
    value: '',
    key: 'salePerson',
  },
  {
    label: '地址',
    value: '',
    key: 'address',
  },
])
const authenticationInfo = [
  {
    label: '企业名称',
    value: '',
  },
  {
    label: '企业负责人',
    value: '',
  },
  {
    label: '企业地址',
    value: '',
  },
  {
    label: '社会统一代码',
    value: '',
  },
  {
    label: '负责人电话',
    value: '',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(authenticationInfo, (item, index) => {
      return _createElementVNode("p", {
        key: index,
        class: "ws_mb25"
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1),
        _createTextVNode(" : "),
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.value || '-'), 1)
      ])
    }), 64))
  ]))
}
}

})